/**
 * Computeds and methods around selected content.
 *
 * Depends on:
 *   - this.contents
 */

import {getMainTVSpotFromBundle} from '@/utils';
import {isTVSpotBundle} from '@/mixins/identifiers';
import store from '@/store';

// Add additional actions/modes here as needed.
export const CONTENT_SELECTION_MODES = {
  activate: 'ACTIVATE',
  deactivate: 'DEACTIVATE',
  delete: 'DELETE',
  bundle: 'BUNDLE',
  refreshDate: 'REFRESH_DATE',
};

export default {
  computed: {
    selectedContents() {
      return this.contents.filter((content) => {
        if (content.kind === 'tvspotbundle') {
          const bundle = content;
          const mainTvSpot = getMainTVSpotFromBundle(bundle);
          return mainTvSpot.selected;
        }
        return content.selected;
      });
    },
    selectedTVSpotBundles() {
      return this.selectedContents.filter(
        (content) => content.kind === 'tvspotbundle'
      );
    },
    atLeastOneContentSelected() {
      return this.selectedContents.length > 0;
    },
    allContentsSelected() {
      return (
        this.selectedContents.length > 0 &&
        this.selectedContents.length === this.contents.length
      );
    },
  },
  methods: {
    deselectAllContents() {
      this.setAllContentsSelected(false);
    },
    setAllContentsSelected(selected) {
      this.contents.forEach((content) => {
        if (content.kind === 'tvspotbundle') {
          const bundle = content;
          const mainTvSpot = getMainTVSpotFromBundle(bundle);
          mainTvSpot.selected = selected;
        } else {
          content.selected = selected;
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/contentSelection.js